/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */

import { types } from "mobx-state-tree"
import { QueryBuilder } from "mst-gql"
import { ModelBase } from "./ModelBase"
import { UnscheduledReasonCodeEnumType } from "./UnscheduledReasonCodeEnum"
import { RootStoreType } from "./index"


/**
 * SolutionUnscheduledDtoBase
 * auto generated base class for the model SolutionUnscheduledDtoModel.
 */
export const SolutionUnscheduledDtoModelBase = ModelBase
  .named('SolutionUnscheduledDto')
  .props({
    __typename: types.optional(types.literal("SolutionUnscheduledDto"), "SolutionUnscheduledDto"),
    id: types.identifier,
    visitId: types.union(types.undefined, types.string),
    reason: types.union(types.undefined, types.string),
    /** Classified form of `reason`; null when the engine string is not recognized. */
    reasonCode: types.union(types.undefined, types.null, UnscheduledReasonCodeEnumType),
  })
  .views(self => ({
    get store() {
      return self.__getStore<RootStoreType>()
    }
  }))

export class SolutionUnscheduledDtoModelSelector extends QueryBuilder {
  get id() { return this.__attr(`id`) }
  get visitId() { return this.__attr(`visitId`) }
  get reason() { return this.__attr(`reason`) }
  get reasonCode() { return this.__attr(`reasonCode`) }
}
export function selectFromSolutionUnscheduledDto() {
  return new SolutionUnscheduledDtoModelSelector()
}

export const solutionUnscheduledDtoModelPrimitives = selectFromSolutionUnscheduledDto().visitId.reason.reasonCode
